/**
 * Apis Jorrt Request Detail Formatter.
 *
 * Renders the request headers, request content and response in read-only
 * textareas when a request row is expanded.
 */
window.apisJorrtRequestDetailFormatter = function(index, row) {
    function pretty(str) {
        if (!str) {
            return "";
        }
        try {
            return JSON.stringify(JSON.parse(str), null, 4);
        } catch (e) {
            return str;
        }
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    }

    function block(label, str) {
        let html = "";
        html += '<div class="mb-3">';
        html += '<label class="fw-bold mb-1">' + label + "</label>";
        html += '<textarea class="form-control" rows="6" readonly>' + escapeHtml(pretty(str)) + "</textarea>";
        html += "</div>";
        return html;
    }

    let html = "";
    html += '<div class="p-2">';
    html += block(__("Request-Headers"), row.headers);
    html += block(__("Request-Content"), row.content);
    html += block(__("Response"), row.response);
    html += "</div>";

    return html;
};
